import type { Role } from '@veem/schema'
import { createSnapshotValue as createMutable } from '../../lib/snapshot-value.ts'

export interface Person {
  id: string
  version?: number
  openTaskCount?: number
  name: string
  role: Role
  title: string
  /** The sign-in. Accounts are created by an admin; there is no self sign-up. */
  email: string
  phone: string | null
  /** Where a shop worker or foreman stands. The work queue offers them jobs from it first. */
  workCenter: string | null
  workCenters: string[]
  createdAt: string
  lastSeenAt: string | null
  /** Devices currently signed in. Ending sessions signs every one of them out. */
  sessions: number
  /** A disabled account keeps its history but can no longer sign in or be assigned work. */
  disabledAt: string | null
}

export const PEOPLE: Person[] = createMutable([] as Person[])

export const isActive = (candidate: Person) => !candidate.disabledAt

/**
 * Who can be picked for new work: active people, optionally of some roles. Someone already on a
 * record stays in its list (marked) even after being disabled, so the field never goes blank.
 */
export const pickable = (roles?: Role[], currentId?: string | null): Person[] =>
  PEOPLE.filter(
    (candidate) =>
      (isActive(candidate) && (!roles || roles.includes(candidate.role))) ||
      candidate.id === currentId,
  )

export const pickLabel = (candidate: Person) =>
  isActive(candidate) ? candidate.name : `${candidate.name} (вимкнено)`

export const personById = (id: string): Person => {
  const person = PEOPLE.find((candidate) => candidate.id === id)
  if (!person) throw new Error(`Unknown prototype person ${id}`)
  return person
}

export const initials = (name: string): string =>
  name
    .split(' ')
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
